export const BOOSTAIL_SET_USER = 'BOOSTAIL_SET_USER';
export const BOOSTAIL_RESET = 'BOOSTAIL_RESET';

export const ANALYTICS_IDENTITY = 'ANALYTICS_IDENTITY';
export const ANALYTICS_RESET = 'ANALYTICS_RESET';
